import { useDataSubmit } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onActionSave = useDataOnActionSave(props, data)
  let onActionCancel = useDataOnActionCancel(props, data)

  return async function onSubmit({ value, change, args }) {
    switch (args?.type) {
      case 'save': {
        return onActionSave({ value })
      }
      case 'cancel': {
        return onActionCancel()
      }
      default: {
      }
    }
  }
}

/** @type {import('Simple/type.js').useDataOnSubmit} */
function useDataOnActionSave(props) {
  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return async function onAction({ value }) {
    let referrals = value.filter(item => {
      if (!item?.id) return false

      switch (item.template.type) {
        case 'DropDown':
          return item.selected_index !== null
        case 'FreeText':
          return item.text_value !== ''
        case 'Search':
          return typeof item.person !== 'undefined'
        default:
          return false
      }
    })

    submit({
      type: 'updateReferrals',
      referrals,
    })

    if (typeof props.closePopover === 'function') props.closePopover()
  }
}

/** @type {import('Simple/type.js').useDataOnSubmit} */
function useDataOnActionCancel(props) {
  return async function onAction() {
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
